import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import DateOfReportContainer from '~/components/Fnol/NewFnolUI/IncidentDetails/DateOfReportContainer';
import { usePolicy } from '~/components/PolicyContainer';

import GenericClaimBarField from './GenericClaimBarField';

type DateOfReportProps = {
  displayName?: string;
};

const DateOfReport = ({ displayName = 'Date of Report' }: DateOfReportProps) => {
  const { claim, onAsyncClaimUpdate } = useClaim({ claimRequired: true });
  const { policy } = usePolicy();

  return policy?.is_claims_made ? (
    <GenericClaimBarField title={displayName} allowWrapping={false}>
      {/*hack *: is child, this targets child of child*/}
      <div className="*:*:text-nowrap">
        <DateOfReportContainer claim={claim} onUpdate={onAsyncClaimUpdate} withoutLabelOnReadOnly />
      </div>
    </GenericClaimBarField>
  ) : null;
};

export default DateOfReport;
